// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

// element框架
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

// 公式渲染
import VueKatex from 'vue-katex'
import 'katex/dist/katex.min.css'

// 组件拖动可编辑
// import vdr from 'vue-draggable-resizable-gorkys'
// import 'vue-draggable-resizable-gorkys/dist/VueDraggableResizable.css'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import formCreate from '@form-create/element-ui'

import Constant from './config/constant.js'

Vue.config.productionTip = false

Vue.use(ElementUI, {})

Vue.use(VueKatex, {
  globalOptions: {
    // ... Define globally applied KaTeX options here
  }
})

// Vue.component('vdr', vdr)

Vue.use(formCreate)
Vue.use(Constant)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js